import { analytics_methods } from "../utils/analytics_methods";

function triggerPageViewEvents() {
  const currentPage = window?.analytics_buendia?.page_type;

  if (currentPage === "checkout") {
    analytics_methods.triggerEvent("analytics.view.ecommerce.checkout");
    analytics_methods.triggerEvent("analytics.view.default.page_identifier");
    return;
  }

  if (currentPage === "pdp") {
    analytics_methods.triggerEvent("analytics.view.ecommerce.pdp");
    return;
  }

  if (currentPage === "purchase") {
    analytics_methods.triggerEvent("analytics.view.ecommerce.purchase");
    return;
  }
}

function triggerInteractionEvents() {
  const checkoutForm = document.querySelector("#buendia-checkout-form");
  let formValues = {};

  if (checkoutForm) {
    checkoutForm.addEventListener("submit", function () {
      const inputs = checkoutForm.querySelectorAll("input");

      formValues = {};

      inputs.forEach((input) => {
        if (input.name) formValues[input.name] = input.value;
      });

      const [year, month, day] = formValues?.date.split("-");
      const dateSelected = `${day}-${month}-${year}`;

      if (dateSelected) window.analytics_buendia.date_selected = dateSelected;
      if (formValues?.selected_hour) window.analytics_buendia.time_selected = formValues?.selected_hour;
      if (formValues?.selected_tickets) window.analytics_buendia.selected_tickets = JSON.parse(formValues?.selected_tickets);
      if (formValues?.selected_tickets_extra) window.analytics_buendia.selected_tickets_extra = JSON.parse(formValues?.selected_tickets_extra);
      if (formValues?.selected_tickets_extra_ticket) window.analytics_buendia.selected_tickets_extra_ticket = JSON.parse(formValues?.selected_tickets_extra_ticket);


      analytics_methods.triggerEvent(
        "analytics.interaction.ecommerce.add-to-cart"
      );
    });
  }
}

function triggerClickEvents() {
  const items = document.querySelectorAll("[data-gtm-click]");

  if (items.length > 0) {
    items.forEach(function (item) {
      item.addEventListener("click", function () {
        if (this.id === "edit-payment-information-next")
          document.dispatchEvent(
            new CustomEvent("analytics.interaction.ecommerce.add-payment-info")
          );
      });
    });
  }
}

function init() {
  triggerPageViewEvents();
  triggerInteractionEvents();
  triggerClickEvents();
}

export const eventTriggers = {
  init,
};
